export const StaticForm_LanguageTeacherInfoByTeacher = "languageteacherInfobyteacher";
export const StaticForm_LanguageTeacherInfoByOther = "languageteacherInfobyother";
export const StaticForm_LanguageTeacherRecommendations = "languageteacherRecommendations";
